export const TRADING_ASSET_CHART_TIMELINE_DATES_GAP_BEFORE_HIDE = 4;

export const TRADING_ASSET_CHART_CANVAS_HEIGHT = 242;

export const TRADING_ASSET_CHART_TIMELINE_HEIGHT = 20;

export const TRADING_ASSET_CHART_HEIGHT =
  TRADING_ASSET_CHART_CANVAS_HEIGHT - TRADING_ASSET_CHART_TIMELINE_HEIGHT;

export const TRADING_ASSET_CHART_LOADING_SCREEN_HEADER = "Loading Chart";

export const TRADING_ASSET_CHART_LOADING_SCREEN_DESCRIPTION =
  "We are loading, please wait.";
